export const API_ENDPOINT = {
  Profile: {
    api: "/admin-api/v1/profile",
    method: "GET",
  },
  Login: {
    api: "/auth/v1/login",
    method:'POST',
    magicToken:"/auth/v1/magic-token",
    tokenVerify:"/auth/v1/magic-token/verify"
  },
  Identify: {
    api: "/auth/v1/identify",
    method:'POST'
  },
  Otp: {
    api: "/auth/v1/verifyOTP",
    method:'POST'
  },
  Vendor: {
    api: "/admin-api/v1/vendors",
    user: "/admin-api/v1/vendors/users",
    method: "GET",
  },
  SubVendor: {
    api: "/admin-api/v1/sub-vendors",
    method: "GET",
    moreApi:"/admin-api/v1/sub-vendors/more-details"
  },
  Compliance: {
    api: "/admin-api/v1/compliance-submissions",
    method: "GET",
  },
  ConfigCompliance: {
    api:"/admin-api/v1/compliances",
    verificationApi:'/admin-api/v1/compliance-verifications'
  },
  OnBoardCompliance: {
    api: "/admin-api/v1/onboard-compliances",
    method: "GET",
  },
  Driver:{
    api:"/admin-api/v1/drivers",
    matrixApi:"/admin-api/v1/drivers/matrix",
    ticketApi:"/admin-api/v1/drivers/tickets",
    moreApi:"/admin-api/v1/drivers/more-details"
  },
  Faq:{
    api:"/admin-api/v1/faqs",
    sectionApi:"/admin-api/v1/faq-sections",
    subSectionApi: "/admin-api/v1/faq-sub-sections"
  },

  Car:{
    api:"/admin-api/v1/config-cars",
    facilitiesApi:"/trip-api/v1/get-facilities"
  },
  Tag:{
    api:"/admin-api/v1/tags"
  },
  Rating:{
    api:"/admin-api/v1/ratings"
  },
  Customer:{
    api:"/admin-api/v1/customers",
    matrixApi:"/admin-api/v1/customers/matrix",
    ticketApi:"/admin-api/v1//customers/tickets",
  },
  Dashboard:{
    registrationApi:"/admin-api/v1/total-rides",
    rideDetailsApi:"/admin-api/v1/subvendor-ride-details",
    rideAnalyticApi:"/admin-api/v1/daily-ride-analytics",
    ourCustomerApi:"/admin-api/v1/our-daily-customers",
    ourCarApi: "/admin-api/v1/our-cars",
    cabRideApi: "/admin-api/v1/get-cab-ride-details",
    topVendorApi: "/admin-api/v1/get-top-vendor",
    topSubVendorApi: "/admin-api/v1/get-top-sub-vendor",
    topDriverApi: "/admin-api/v1/get-top-drivers",
    rideAcceptApi: "/admin-api/v1/ride-acceptance",
    dashboardFeedbackApi: "/admin-api/v1/get-feedback",
  },
  Vehicle:{
    api:"/admin-api/v1/company-vehicles",
    matrixApi:"/admin-api/v1/vehicle-matrix",
    moreApi:"/admin-api/v1/compliance-submission-values"
  },
  Registration:{
    api:"/auth/v1/register",
  },
  Trip:{
    api:"/trip-api/v1/trip-listing/",
    sosApi:"/trip-api/v1/emergencyAlerts",
    cancelApi:"/trip-api/v1/cancel-trips",
    assignDriverApi:"/admin-api/v1/driver-assigns",
    assignSubvendorResponseApi:"/admin-api/v1/assign-subvendor-response",
    assignDriverToTripApi:"/admin-api/v1/assign-driver",
    invoiceApi:"/trip-api/v1/invoices",
    invoiceDownloadApi:"/trip-api/v1/download-invoices"
  },
  Notification:{
    api:"/admin-api/v1/notification",
    countApi:"/admin-api/v1/notification/count",
    seenApi:"/admin-api/v1/notification/seen"
  },
  AssignVehicle:{
    requestVehicleApi:"/admin-api/v1/vehicle-list",
    listAssignedVehicleApi:"/admin-api/v1/assigned-vehicle-list",
    assignVehicleApi:"/admin-api/v1/assign-vehicle",
    assignDriverApi:'/admin-api/v1/assign-driver',
    assignSubVendorApi:'/admin-api/v1/assign-subvendor',

  },
  ChooseYourService:{
    api:"/trip-api/v1/trip-services",
  },
  RateCard:{
   api:"/admin-api/v1/rate-cards",
   baseFuelApi:"/admin-api/v1/base-fuel-rates"
  },

  ServiceCity:{
    api:"/trip-api/v1/service-cities",
    serviceRegion:"/trip-api/v1/service-regions",
    subVendorRegion:"/admin-api/v1/subvendor-serviceable-regions"
  },
  Logout:{
    api:"/auth/v1/logout"
  },
  Report:{
    bookingApi:"/admin-api/v1/booking-status"
  },
  MapApi:{
    api:"https://maps.googleapis.com/maps/api/"
  },
  bookingDetails:{
    api: "/trip-api/v1/b2b-trips/",
  }

}